import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { toast, BackdropLoader } from '@livable/saas-react-components';
import { Typography, Button, TableContainer, TableHead, Table, TableCell, TableBody, TableRow, Radio } from '@mui/material';
import { useStore } from 'src/stores';
import { FilePreviewModal } from 'src/components/shared/FilePreviewModal';
export const ActivateAutoBillingModalForm = observer(_ref => {
  let urjanetCredentialsForProvider = _ref.urjanetCredentialsForProvider,
    handleModalClose = _ref.handleModalClose,
    propertyUtility = _ref.propertyUtility,
    callbackTrigger = _ref.callbackTrigger;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    filePreviewLink = _useState6[0],
    setFilePreviewLink = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    fileName = _useState8[0],
    setFileName = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isFilePreviewModalOpen = _useState0[0],
    setIsFilePreviewModalOpen = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    filePreviewModalRow = _useState10[0],
    setFilePreviewModalRow = _useState10[1];
  const _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    statementRows = _useState12[0],
    setStatementRows = _useState12[1];
  const fetchStatements = async () => {
    setIsLoading(true);
    return store.urjanet.getProviderStatementsPreviewAsync.run({
      livableProviderId: urjanetCredentialsForProvider === null || urjanetCredentialsForProvider === void 0 ? void 0 : urjanetCredentialsForProvider.livableProviderId
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        setStatementRows(resp === null || resp === void 0 ? void 0 : resp.response);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const saveStatement = async _ref2 => {
    let accountId = _ref2.accountId;
    setIsLoading(true);
    return store.urjanet.setAccountPropertyUtilityAsync.run({
      urjanetId: accountId,
      livablePropertyUtilityId: propertyUtility.propertyUtilityId
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: ['Activation completed']
        });
      }
    }).finally(() => {
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchStatements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(statementRows !== null && !!statementRows.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.caption
  }, t('add_new_property_flow.urjanet_accounts_pending_fetch'))) : /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.caption
  }, t('add_new_property_flow.please_select_which_of_the_following_urjanet_accounts', {
    utilityName: propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || ''
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, t('add_new_property_flow.founded_account_Ids')), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, t('add_new_property_flow.last_bill_preview')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('add_new_property_flow.last_bill_charge')))), /*#__PURE__*/React.createElement(TableBody, null, statementRows !== null && !!statementRows.length && (statementRows === null || statementRows === void 0 ? void 0 : statementRows.map((row, i) => /*#__PURE__*/React.createElement(TableRow, {
    key: i,
    className: value === row.accountId ? 'active' : ''
  }, /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Radio, {
    disabled: !(row !== null && row !== void 0 && row.billPreviewLink),
    checked: value === row.accountId,
    onChange: () => setValue(row.accountId),
    value: row.accountId,
    name: "radio-buttons"
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, row === null || row === void 0 ? void 0 : row.accountNumber), /*#__PURE__*/React.createElement(TableCell, {
    align: "left",
    disabled: !(row !== null && row !== void 0 && row.billPreviewLink),
    onClick: () => {
      if (row !== null && row !== void 0 && row.billPreviewLink) {
        setFilePreviewLink(row === null || row === void 0 ? void 0 : row.billPreviewLink);
        setFileName(row === null || row === void 0 ? void 0 : row.fileName);
        setFilePreviewModalRow(row);
        setIsFilePreviewModalOpen(true);
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: (row === null || row === void 0 ? void 0 : row.billPreviewLink) && classes.modalTrigger
  }, !!(row !== null && row !== void 0 && row.billPreviewLink) ? row === null || row === void 0 ? void 0 : row.fileName : 'Pending')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, row === null || row === void 0 ? void 0 : row.statementAmount)))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '187-activate-auto-billing-modal'
  }, t('general.close'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: value === null,
    type: "button",
    variant: "contained",
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      saveStatement({
        accountId: value
      }).then(response => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        callbackTrigger && callbackTrigger();
        handleModalClose();
      });
    },
    'custom-attribute': '188-activate-auto-billing-modal'
  }, t('admin_page.activate')))))), /*#__PURE__*/React.createElement(FilePreviewModal, {
    docUri: filePreviewLink,
    fileName: fileName,
    isOpen: isFilePreviewModalOpen,
    handleClose: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    handleOpen: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    isPreviewOnly: true,
    rightActionButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: () => {
        setValue(filePreviewModalRow.accountId);
        setIsFilePreviewModalOpen(false);
      },
      'custom-attribute': '189-activate-auto-billing-modal'
    }, t('add_new_property_flow.yes_its_the_right_one'))
  }));
});